module.exports = __webpack_public_path__ + "static/media/kp.bab86a27.svg";